import cookies from 'js-cookie'
import settings from './settings'

cookies.defaults.expires = settings.COOKIE_EXPIRES

export default cookies
